import { ClickAwayListener, Fade, IconButton, Paper } from '@material-ui/core';
import { MeetingRoom, KeyboardArrowDown } from '@material-ui/icons';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Hamburger } from '../assets/icons';
import { Colors } from '../assets/statics';
import { CustomButton, CustomIconButton, CustomPopperUser, HeaderWrapper } from '../assets/styled';
import { setAppConfig, setActiveUser } from '../store/actions';

const headerTitleData = [
  { text: 'Ana Sayfa', hash: '/' },
  { text: 'Kullanıcılar', hash: '/Users' },
  { text: 'Diller', hash: '/Languages' },
  { text: 'Kategori', hash: '/Categories' },
  { text: 'Kelimeler', hash: '/Words' },
  { text: 'Paketler', hash: '/Packages' },
  { text: 'Kuponlar', hash: '/Coupons' },
  { text: 'Ayarlar', hash: '/WebPage' },
  { text: 'Bloglar', hash: '/Blogs' },
  { text: 'Yeni Blog', hash: '/NewBlog' },
  { text: 'Yardımcılar', hash: '/Helpers' },
  { text: 'Ödemeler', hash: '/Payments' },
  { text: 'Toplu Satışlar', hash: '/BulkSales' },
  { text: 'Bug Reports', hash: '/Bug-reports' },
  { text: 'Kurslar', hash: '/Course' },
  { text: 'Bildirimler', hash: '/Notifications' },
];

function Header() {
  const sidebarStatu = useSelector(state => state.appConfig.sidebar);
  const [userAnchor, setUserAnchor] = useState(false);
  const [headerTitleState, setHeaderTitleState] = useState('');
  const dispatch = useDispatch();
  const setSidebarStatu = useCallback(() => dispatch(setAppConfig('sidebar', !sidebarStatu)), [dispatch, sidebarStatu]);
  const activeUser = useSelector(state => state.activeUser);

  function logOut() {
    dispatch(setActiveUser({}));
    localStorage.removeItem('token');
    window.location.href = '#/Login';
  }

  useEffect(() => {
    const currentHash = window.location.hash !== '#/' ? window.location.hash.split('/')[1] : '/';
    const found = headerTitleData.find(x => x.hash.includes(currentHash)) || headerTitleData[0];
    setHeaderTitleState(found.text);
  }, [window.location.hash]);

  return (
    <HeaderWrapper sideOpen={sidebarStatu}>
      <div className="fixed">
        <div className="left">
          <IconButton onClick={setSidebarStatu}>
            <Hamburger />
          </IconButton>
          <span>{headerTitleState}</span>
        </div>
        
        <div className="right">
          <div className="profile" onClick={e => setUserAnchor(e.currentTarget)}>
            <div className="capitalNameBox">
              <span>
                {activeUser?.name?.split(' ')?.[0]?.charAt(0)}
                {activeUser?.name?.split(' ')?.[1]?.charAt(0)}
              </span>
            </div>
            <div className="name">
              <h4>{activeUser?.name || 'Yönetici'}</h4>
              <p>Admin Panel</p>
            </div>
            <KeyboardArrowDown style={{ fill: '#00F2FF', marginLeft: 10, fontSize: 20 }} />
          </div>
        </div>
      </div>

      <CustomPopperUser open={Boolean(userAnchor)} anchorEl={userAnchor} placement="bottom-end" transition>
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={() => setUserAnchor(false)}>
            <Fade {...TransitionProps} timeout={300}>
              <Paper>
                <CustomButton simple startIcon={<MeetingRoom />} onClick={logOut}>
                  Güvenli Çıkış
                </CustomButton>
              </Paper>
            </Fade>
          </ClickAwayListener>
        )}
      </CustomPopperUser>
    </HeaderWrapper>
  );
}

export default Header;